export default {
    endpoint : "ProjetoEmpresaCooperada",
    nomeIdProjeto : 'projetoCooperadaId',
    endpointProposta : 'PropostaEmpresaCooperada',
    componentes : [
        {
            tela: 'aneel',
            titulo: 'OBRIGAÇÕES NA ANEEL',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdObrigacoesAneel',
        },
        {
            tela: 'empresas-executoras',
            titulo: 'EMPRESAS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdEmpresas',
        },
        {
            tela: 'rh',
            titulo: 'RH - RECURSOS HUMANOS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdRecursoHumano',
        },
        {
            tela: 'st',
            titulo: 'ST - SERVICO DE TERCEIROS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdServicoTerceiro',
        },
        {
            tela: 'mc',
            titulo: 'MC - MATERIAL DE CONSUMO',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdMaterialConsumo',
        },
        {
            tela: 'mpe',
            titulo: 'MPE - MATERIAIS PERMANENTES E EQUIPAMENTOS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdMaterialPermanente',
        },
        {
            tela: 'vd',
            titulo: 'VD - VIAGENS E DIÁRIAS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdViagemDiaria',
        },
        {
            tela: 'ou',
            titulo: 'OU - OUTROS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdOutros',
        },
        {
            tela: 'entregavel',
            titulo: 'ENTREGÁVEIS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdEntregaveis',
        },
        {
            tela: 'cronograma_etapa',
            titulo: 'CRONOGRAMA DE ETAPAS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdCronogramaEtapa',
        },
        {
            tela: 'cronograma_financeiro',
            titulo: 'CRONOGRAMA FINANCEIRO',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdCronogramaFinanceiro',
        },
        {
            tela: 'investimentos',
            titulo: 'DISTRIBUIÇÃO POR RUBRICAS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdInvestimentos',
        },
        {
            tela: 'documentos',
            titulo: 'CONTRATO E DOCUMENTAÇÃO ADICIONAL',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdContrato',
        },
        {
            tela: 'caracteristicas',
            titulo: 'CARACTERÍSTICAS DO PROJETO',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdCaracteristicaProjeto',
        },
        {
            tela: 'trl',
            titulo: 'TRL - GRAU DE MATURIDADE TECNOLÓGICA',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdTRL',
        },

        {
            tela: 'cp',
            titulo: 'CP - CAPACITAÇÃO PROFISSIONAL',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdCapacitacaoProfissional',
        },
        {
            tela: 'pc',
            titulo: 'PC - PRODUÇÃO CIENTÍFICA / CAPACITAÇÃO TECNOLÓGICA',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdProducaoCientifica',
        },
        {
            tela: 'aie',
            titulo: 'AIE - APOIO À INFRAESTRUTURA',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdApoioInfraestrutura',
        },
        {
            tela: 'pi',
            titulo: 'PI - PROPRIEDADE INTELECTUAL',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdPropriedadeIntelectual',
        },
        {
            tela: 'isa',
            titulo: 'ISA - IMPACTOS SOCIOAMBIENTAIS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdImpactosSocioambientais',
        },
        {
            tela: 'ie',
            titulo: 'IE - IMPACTOS ECONÔMICOS',
            esconderTitulo: false,
            chavePermissao: 'ProjetosPdImpactosEconomicos',
        },
    ]
}